/**
 * @param language 'en' as default
 */
export default function getProofOfAddressFaqLink(language?: string): string {
  switch (language) {
    default:
      return 'https://support.bake.io/en/articles/8286196-which-documents-are-accepted-as-proof-of-address-poa-for-kyc-level-2';
  }
}
